import { useMutation } from '@tanstack/react-query'
import { exportProviders, ExportProvidersParams } from './requests'

type UseExportProvidersOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useExportProviders = (options?: UseExportProvidersOptions) => {
  return useMutation({
    mutationFn: (params: ExportProvidersParams) => exportProviders(params),
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
